// extracted by mini-css-extract-plugin
module.exports = {"container":"cVxdEbNUS_FWH_0VD5g_5","restaurantsList":"ftux-DkusViqfGtmmc9wN"};